module.exports = __webpack_public_path__ + "static/media/link1.e49f11d2.png";